import { PELOTON_PLATFORM } from './env';
export var toPlatformPath = function toPlatformPath() {
  switch (PELOTON_PLATFORM) {
    case 'sky_tv':
      return 'sky';

    case 'lg':
      return 'lg';

    case 'samsung':
      return 'samsung';

    default:
      return '';
  }
};